import { addCircle } from '../components/circle';
import { Colors } from '../constants/colors';
import { GAME_WIDTH, MIDDLE_WIDTH } from '../constants/constants';
import { Scenes } from '../constants/scenes';
import { mainMusic } from '../main';
import { GameState } from '../types/game-state';

export const characterSelectionScene = () =>
  scene(Scenes.CHARACTER_SELECTION, () => {
    debug.log('in main menu');

    add([
      text('pick your character', { font: 'arial', width: 600 }),
      color(...Colors.BLACK),
      // put into middle top of the screen
      pos(GAME_WIDTH / 2 - 150, 50),
    ]);

    // Below "draws" all the circles in a grid that can then be selected
    // This will be the player's color for the rest of the game, and the rest
    // of any generated NPCs will not have this color.
    for (let i = 0; i < Object.keys(Colors).length; i++) {
      const [colorName, colorRGB] = Object.entries(Colors)[i];
      const initialVerticalOffset = 150;

      const x = (i % 4) * 75 + MIDDLE_WIDTH - 100;
      const y = Math.floor(i / 4) * 75 + initialVerticalOffset;

      const pos = vec2(x, y);

      const circle = addCircle({
        pos,
        color: rgb(...(colorRGB as [number, number, number])),
      });

      circle.onMousePress((mouseButton) => {
        if (mouseButton !== 'left') return;
        const currMousePos = mousePos();

        const isOverCircle = currMousePos.dist(pos) < 32;

        if (isOverCircle) {
          debug.log('clicked on circle', colorName);
          mainMusic.play();
          go(Scenes.LANGUAGE_SELECTION, {
            playerColor: colorName,
          } as Pick<GameState, 'playerColor'>);
        }
      });
    }
  });
